var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
// module id = null
// module chunks = 